<template>
  <div class="d-flex align-center">
    <widget-country
      class="font-weight-normal mr-1"
      :country-code="option.value"
      :title="option.text"
    />

    <span class="font-weight-normal light--text">
      {{ `(+${option.code})` }}
    </span>
  </div>
</template>

<script lang="ts">
import WidgetCountry from '@widgets/shared/components/WidgetCountry.vue'
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'
import type { CountryPhoneData } from '@/constants/countryPhoneData'

export default defineComponent({
  components: {
    WidgetCountry,
  },
  props: {
    option: {
      type: Object as PropType<CountryPhoneData>,
      required: true,
    },
  },
})
</script>
